/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$('body').on('click', '.step-form.banner .c-btn', function(e){ console.log('yes');
  e.preventDefault();
  $(this).closest('.shopify-section').hide();
  $('.step-form.age-verify').show();
    
});

$('body').on('click', '.age-options .option', function(){
  var option = $(this).attr('data-target');
  $('.answer .option').hide();
  $('.answer [data-target="'+option+'"]').show();
  var section = $(this).closest('.shopify-section');
  setTimeout(function(){
    section.hide();
    $('.step-form.member-form').show();
  },4000);
});

// $('body').on('click', '.step-form.age-verify .answer .option', function(){
//    $(this).closest('.shopify-section').hide();
//    $('.step-form.member-form').show();
// });
